import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import "./ManageUser.scss";
import OrganizationUsers from "../features/userManagement/OrganizationUsers";
import PendingRequests from "../features/userManagement/PendingRequests";
import { Plus } from "lucide-react";
import AddUserModal from "../features/userManagement/AddUserModal";
import OtpModal from "../features/userManagement/OtpModal";
import { canManageOrgUsers } from "../utils/roles";

const ManageUser = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = searchParams.get("tab");
  const showPending = activeTab === "pending";

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showAddUser, setShowAddUser] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [requestId, setRequestId] = useState<string | null>(null);

  const [pendingRefreshKey, setPendingRefreshKey] = useState(0);

  const handleAddUserSuccess = (reqId: string) => {
    setRequestId(reqId);
    setShowAddUser(false);
    setShowOtp(true);
    setPendingRefreshKey((k) => k + 1);
  };

  return (
    <div className="manageuser-container">
      <Sidebar className={isSidebarOpen ? "open" : ""} />
      {isSidebarOpen && (
        <div className="overlay" onClick={() => setIsSidebarOpen(false)} />
      )}

      <div className="manageuser-content">
        <Header
          onMenuClick={() => setIsSidebarOpen((p) => !p)}
          rightActions={
            canManageOrgUsers() ? (
              <button className="add-btn" onClick={() => setShowAddUser(true)}>
                <Plus size={18} /> Add User
              </button>
            ) : undefined
          }
        />

        {showPending ? (
          <PendingRequests
            refreshKey={pendingRefreshKey}
            onBack={() => setSearchParams({})}
            onVerify={(reqId) => {
              setRequestId(reqId);
              setShowOtp(true);
            }}
          />
        ) : (
          <OrganizationUsers
            onPendingClick={() => setSearchParams({ tab: "pending" })}
          />
        )}
      </div>

      {showAddUser && (
        <AddUserModal
          onClose={() => setShowAddUser(false)}
          onSuccess={handleAddUserSuccess}
        />
      )}

      {showOtp && requestId && (
        <OtpModal
          requestId={requestId}
          onClose={() => {
            setShowOtp(false);
            setRequestId(null);
          }}
          onSuccess={() => {
            setShowOtp(false);
            setRequestId(null);
            setPendingRefreshKey((k) => k + 1);
          }}
        />
      )}
    </div>
  );
};

export default ManageUser;
